import AddCircleIcon from "@mui/icons-material/AddCircle";
import {
  Accordion,
  AccordionDetails,
  Box,
  Container,
  Grid,
  Stack,
} from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import VSNLoader from "../../shared/VSNLoader";
import VSNProgressiveImage from "../../shared/VSNProgressiveImage";
import VSNTypography from "../../shared/VSNTypography";
import { getContentTypeDetails } from "./LearningConstant";
import { LearningStyle } from "./LearningStyle";
import videoImage from "../../assets/learning/video.webp";

const LearningCourseDetails = ({ data, course_id, loader }) => {
  const classes = LearningStyle();
  const navigate = useNavigate();
  const [showAll, setShowAll] = useState(false);
  const [expandedIndex, setExpandedIndex] = useState(0);

  const displayedData = showAll ? data?.lessons : data?.lessons?.slice(0, 3);
  const userData = useSelector((state) => state?.app?.userData);
  const bookMarkData = userData?.bookmark || [];

  const toggleAccordion = (index) => {
    setExpandedIndex((prev) => (prev === index ? -1 : index));
  };

  const handleToggleShow = () => setShowAll((prev) => !prev);

  if (loader) {
    return <VSNLoader variant="transParent" />;
  }

  return (
    <>
      <Container maxWidth="xl" sx={{ p: { sx: 4, xs: 0 } }}>
        <Box pt={3}>
          {/* <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            mt={2}
          >
            <VSNBreadcrumbs {...{ breadcrumbsRoutes }} />
            <Box
              sx={{
                height: "56px",
                width: "56px",
                backgroundColor: "#FEF6EE",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "4px",
              }}
            >
              <SchoolRoundedIcon
                fontSize="large"
                style={{ color: "var(--secondary)" }}
              />
            </Box>
          </Stack> */}

          <Box position="relative" className={classes.courseImage}>
            <VSNProgressiveImage
              src={data?.thumbnail}
              placeholder={videoImage}
              alt="Course"
              style={{ objectFit: "cover", borderRadius: "16px" }}
            />
            <Box className={classes.courseTitle}>
              <VSNTypography
                variant="h3"
                fontSize={{ sm: "3rem", xs: "1.5rem" }}
              >
                {data?.title ?? ""}
              </VSNTypography>

              {/* <VSNTypography variant="h1" className={classes.lgHeading}>
                {data?.title ?? ""}
              </VSNTypography> */}
              {/* <AddCircleIcon fontSize="large" style={{ color: "#fff" }} /> */}
            </Box>
          </Box>
        </Box>

        <Grid container spacing={{ sm: 4 }} mt={2} maxWidth="xlg" margin="auto">
          <Grid item xs={12} md={8}>
            <Stack gap={1} mt={3}>
              <VSNTypography
                dangerouslySetInnerHTML={{
                  __html: data?.summary,
                }}
              />

              <VSNTypography pt={2}>
                Instructor(s):{" "}
                <VSNTypography fontWeight="bold" component="span">
                  {data?.instructor ?? ""}
                </VSNTypography>
              </VSNTypography>

              <VSNTypography>
                Class Length:{" "}
                <VSNTypography fontWeight="bold" component="span">
                  {data?.class_length ?? ""}
                </VSNTypography>
              </VSNTypography>

              <Box className={classes.topics}>
                <VSNTypography>Topics Covered:</VSNTypography>
                {data?.tags?.map((tag, index) => (
                  <VSNTypography
                    key={index}
                    sx={{
                      padding: "8px",
                      backgroundColor: "#FEF6EE",
                      borderRadius: "8px",
                      fontWeight: 700,
                      color: "var(--secondary)",
                    }}
                  >
                    {tag}
                  </VSNTypography>
                ))}
              </Box>
            </Stack>

            <Stack mt={4} gap={2}>
              <VSNTypography variant="h5">Table of contents</VSNTypography>

              <Box className={classes.tableOfContents}>
                {/* {displayedData?.map((section, index) => (
                  <Accordion
                    key={section.title}
                    expanded={expandedIndex === index}
                    onChange={() => toggleAccordion(index)}
                    sx={{ boxShadow: "none", backgroundColor: "transparent" }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      sx={{
                        width: "300px",
                        backgroundColor: "#EAEDF0",
                        borderTopRightRadius: 4,
                        borderTopLeftRadius: 4,
                        height: 47,
                        border: "1px solid #CDD0E1",
                      }}
                    >
                      <VSNTypography>
                        <VSNTypography component="span" mr={2}>
                          {index + 1}
                        </VSNTypography>{" "}
                        {section.title}
                      </VSNTypography>
                    </AccordionSummary>

                    <AccordionDetails
                      sx={{
                        border: "1px solid #CDD0E1",
                        borderRadius: 2,
                        borderTopLeftRadius: 0,
                        p: 0,
                      }}
                    >
                      {section.lessons.map((lesson, idx) => {
                        const { icon, label } = getContentTypeDetails(
                          lesson?.course_content?.type
                        );
                        return (
                          <Box
                            key={lesson.title}
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            px={2}
                            py={1.5}
                            onClick={(e) =>
                              navigate(
                                `/learning/content/${lesson?.content_type.toLowerCase()}/${course_id}/${
                                  lesson?.id
                                }`
                              )
                            }
                          >
                            <Box display="flex" alignItems="center" gap={2}>
                              <Box>{icon}</Box>
                              <VSNTypography>{lesson?.name}</VSNTypography>
                            </Box>
                            <VSNTypography>
                              {lesson?.content_duration}
                            </VSNTypography>
                          </Box>
                        );
                      })}
                    </AccordionDetails>
                  </Accordion>
                ))} */}

                {displayedData?.map((section, index) => {
                  const { icon, label } = getContentTypeDetails(
                    section?.content_type?.toLowerCase()
                  );

                  return (
                    <Accordion
                      key={index}
                      expanded={expandedIndex === index}
                      onChange={() => toggleAccordion(index)}
                      sx={{
                        boxShadow: "none",
                        backgroundColor: "transparent",
                        cursor: "pointer",
                      }}
                    >
                      <AccordionDetails
                        sx={{
                          border: "1px solid #CDD0E1",
                          p: 0,
                        }}
                      >
                        <Box
                          key={section.title}
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          px={2}
                          py={1.5}
                          onClick={(e) =>
                            navigate(
                              `/learning/content/${section?.content_type.toLowerCase()}/${course_id}/${
                                section?.id
                              }`
                            )
                          }
                        >
                          <Box display="flex" alignItems="center" gap={2}>
                            <Box>{icon}</Box>
                            <VSNTypography>{section?.name}</VSNTypography>
                          </Box>
                          <VSNTypography>
                            {section?.content_duration}
                          </VSNTypography>
                        </Box>
                      </AccordionDetails>
                    </Accordion>
                  );
                })}

                {data?.lessons?.length > 3 && (
                  <Box textAlign="right">
                    <VSNTypography
                      onClick={handleToggleShow}
                      color="orange.main"
                      sx={{
                        cursor: "pointer",
                        mt: 1,
                        fontWeight: 500,
                        textDecoration: "underline",
                      }}
                    >
                      {showAll ? "Show Less" : "View All"}
                    </VSNTypography>
                  </Box>
                )}
              </Box>
            </Stack>
          </Grid>
          {/* <Grid item xs={12} md={4}>
            <Box
              sx={{
                backgroundColor: "#fff",
                borderRadius: "16px",
                boxShadow: "0px 9px 20px 0px #968FB01A",
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <VSNImage
                  src="https://www.asamby.com/wp-content/uploads/2023/03/meeting-landscape_01.jpg"
                  alt="Course"
                  style={{
                    width: "100%",
                    borderTopLeftRadius: "16px",
                    borderTopRightRadius: "16px",
                  }}
                />
              </Box>

              <Stack padding="24px" gap={2}>
                <Stack direction="row" alignItems="center" gap={2}>
                  <Box sx={{ width: "100%" }}>
                    <LinearProgress variant="determinate" value={30} />
                  </Box>
                  <Box sx={{ minWidth: 35 }}>
                    <VSNTypography
                      variant="body2"
                      sx={{ color: "text.secondary" }}
                    >
                      {`${30}%`}
                    </VSNTypography>
                  </Box>
                </Stack>
                <Stack direction="row" alignItems="center" gap={2}>
                  <Box
                    sx={{
                      height: "30px",
                      width: "30px",
                      backgroundColor: "#F2E7F5",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "4px",
                    }}
                  >
                    <SchoolRoundedIcon style={{ color: "var(--primary)" }} />
                  </Box>
                  <VSNTypography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 400,
                      color: "var(--gray)",
                    }}
                  >
                    0 of 29 Lessons
                  </VSNTypography>
                </Stack>
                <Stack direction="row" alignItems="center" gap={2}>
                  <Box
                    sx={{
                      height: "30px",
                      width: "30px",
                      backgroundColor: "#F0F9F2",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "4px",
                    }}
                  >
                    <QueryBuilderIcon
                      fontSize="small"
                      style={{ color: "#2D8F4E" }}
                    />
                  </Box>
                  <VSNTypography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 400,
                      color: "var(--gray)",
                    }}
                  >
                    Total 1.5 hours of videos
                  </VSNTypography>
                </Stack>

                <VSNButton
                  fullWidth
                  variant="contained"
                  sx={{ mt: 2 }}
                  endIcon={<ArrowForwardIcon />}
                >
                  Start Learning
                </VSNButton>
              </Stack>
            </Box>
          </Grid> */}
        </Grid>
      </Container>
    </>
  );
};

export default LearningCourseDetails;
